import { LayoutProvider } from "../common/layout/layout-provider";
import { PageHeader } from "../common/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ServicesTabContent } from "./services-tab-content";
import { CategoriesTabContent } from "./categories-tab-content";

export function ServicesPage() {
  return (
    <div>
      <PageHeader title="Manage Services" />
      <LayoutProvider>
        <Tabs defaultValue="services">
          <TabsList className="bg-neutral-50 border-b-2 border-border rounded-none w-full p-0 h-auto justify-start">
            <TabsTrigger
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
              value="services"
            >
              Services
            </TabsTrigger>
            <TabsTrigger
              value="categories"
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
            >
              Categories
            </TabsTrigger>
          </TabsList>
          <TabsContent value="services">
            <ServicesTabContent />
          </TabsContent>
          <TabsContent value="categories">
            <CategoriesTabContent />
          </TabsContent>
        </Tabs>
      </LayoutProvider>
    </div>
  );
}
